export default __webpack_public_path__ + "static/media/Gaurav.21fcb1cd.jpg";